import Vue from 'vue'
import XBtn from '@xLib/XBtn'

Vue.component('x-btn', XBtn)
